export default __webpack_public_path__ + "static/media/logo.b1a432c8.svg";